import {EDITING_LEGEND} from "./types";

export function editingLegend(payload) {
    return {
        type: EDITING_LEGEND,
        payload: payload
    };
}